export default __webpack_public_path__ + "static/media/707CEB0E-47D8-4480-9B6F-E65C9C538EE8_1_105_c.0e6947ff.jpeg";